import Tool from '../../common/tool'
// 数据格式化
var index = 0

function dataFormat(data, idx, _this) {
  var price = null
  if (_this.$route.params.type === 0) {
    var keys1 = []
    var vals1 = []
    var keys2 = []
    var vals2 = []

    let arr1 = Tool.sliceArrayByOrder(Tool.dictionaryToArray(data.bj_price), 12)
    if (idx >= arr1.length || idx < 0) {
      return null
    }
    let array1 = arr1[idx]
    for (var i = 0; i < array1.length; i++) {
      keys1.push(array1[i].key)
      vals1.push(array1[i].val)
    }

    let arr2 = Tool.sliceArrayByOrder(Tool.dictionaryToArray(data.price), 12)
    if (idx >= arr2.length || idx < 0) {
      return null
    }
    let array2 = arr2[idx]
    for (var j = 0; j < array2.length; j++) {
      keys2.push(array2[j].key)
      vals2.push(array2[j].val)
    }

    price = {
      legend_data: ['北京', _this.$route.params.name],
      ylabels: keys1,
      series: [{
        name: '北京',
        type: 'line',
        data: vals1,
        label: {
          normal: {
            show: true,
            position: 'left' // 值显示
          }
        }
      }, {
        name: _this.$route.params.name,
        type: 'line',
        data: vals2,
        label: {
          normal: {
            show: true,
            position: 'left'
          }
        }
      }]
    }
  } else {
    let keys = []
    let vals = []

    let arr = Tool.sliceArrayByOrder(Tool.dictionaryToArray(data.price), 12)
    if (idx >= arr.length || idx < 0) {
      return null
    }
    let array = arr[idx]
    for (var n = 0; n < array.length; n++) {
      keys.push(array[n].key)
      vals.push(array[n].val)
    }

    price = {
      legend_data: [_this.$route.params.name],
      ylabels: keys,
      series: [{
        name: _this.$route.params.name,
        type: 'line',
        data: vals,
        label: {
          normal: {
            show: true,
            position: 'top'
          }
        }
      }]
    }
  }
  return price
}

// 设置option
function setupOption(val) {
  var priceOptions = {
    backgroundColor: '#FFFFFF',
    color: ['#FF8000', '#66CCFF'],
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      x: 'right',
      padding: [8, 20, 0, 20],
      data: val.legend_data
    },
    grid: {
      left: '3%',
      right: '5%',
      bottom: '32px',
      containLabel: true
    },
    xAxis: {
      position: 'top',
      splitLine: { // 网格线
        show: true,
        lineStyle: {
          color: ['#B1B1B1'],
          type: 'dashed'
        }
      },
      axisLabel: {
        'interval': 'auto',
        'rotate': 45,
        'show': true,
        'splitNumber': 15,
        'textStyle': {
          'fontFamily': '微软雅黑',
          'fontSize': 12
        }
      }
    },
    yAxis: {
      type: 'category',
      boundaryGap: false,
      splitLine: { // 网格线
        show: true,
        lineStyle: {
          color: ['#B1B1B1'],
          type: 'dashed'
        }
      },
      data: val.ylabels,
      axisLabel: {
        'interval': 0,
        'show': true,
        'splitNumber': 15,
        'textStyle': {
          'fontFamily': '微软雅黑',
          'fontSize': 12
        }
      }
    },
    series: val.series
  }
  return priceOptions
}

// 创建 价格选项
export function creatPriceOptions(data, _this) {
  index = 0
  let price = dataFormat(data, index, _this)
  if (price !== null) {
    return setupOption(price)
  } else {
    return null
  }
}

// 上一个数据
export function nextChart(data, _this) {
  let option = dataFormat(data, ++index, _this)
  if (option !== null) {
    return setupOption(option)
  } else {
    --index
    return null
  }
}

// 下一个数据
export function lastChart(data, _this) {
  let option = dataFormat(data, --index, _this)
  if (option !== null) {
    return setupOption(option)
  } else {
    ++index
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/chartjs/PriceChart.js